export default __webpack_public_path__ + "static/media/u_wdt_c_2.5a2346c1.mp3";